import React from 'react';
import './BCom.css';  // Import the custom CSS for styling

const BCom = () => {
  return (
    <div className="bcom-page">
      <h1 className="page-title">Bachelor of Commerce</h1>
      <p className="intro-text">
        Bachelor of Commerce is a 3-year degree program. The Bachelor of Commerce degree is designed to provide students with a wide range of managerial skills, while building competence in a particular area of business. The B.Com. course list includes Marketing, Accounting, Entrepreneurship, various Taxation, and Industrial Laws, etc.
      </p>

      <div className="bcom-syllabus">
        <div className="semester-section">
          <h2 className="section-title">First Year Bachelor of Commerce</h2>

          {/* First Semester */}
          <div className="syllabus-semester">
            <h3>Semester I (F.Y.B.Com)</h3>
            <ul>
              <li>Accountancy & Financial Management I</li>
              <li>Commerce I</li>
              <li>Business Economics I</li>
              <li>Business Communication I</li>
              <li>Environmental Studies I</li>
              <li>Foundation Course I</li>
              <li>Mathematical and Statistical Techniques I</li>
            </ul>
          </div>

          {/* Second Semester */}
          <div className="syllabus-semester">
            <h3>Semester II (F.Y.B.Com)</h3>
            <ul>
              <li>Accountancy & Financial Management II</li>
              <li>Commerce II</li>
              <li>Business Economics II</li>
              <li>Business Communication II</li>
              <li>Environmental Studies II</li>
              <li>Foundation Course II</li>
              <li>Mathematical and Statistical Techniques II</li>
            </ul>
          </div>
        </div>

        <div className="semester-section">
          <h2 className="section-title">Second Year Bachelor of Commerce</h2>

          {/* Third Semester */}
          <div className="syllabus-semester">
            <h3>Semester III (S.Y.B.Com)</h3>
            <ul>
              <li>Accountancy & Financial Management III</li>
              <li>Discipline Specific Elective (Any One):</li>
              <ul>
                <li>a) Financial Accounting and Auditing – Introduction to Management Accounting</li>
                <li>b) Business Management – Marketing Management</li>
              </ul>
              <li>Commerce III</li>
              <li>Business Economics III</li>
              <li>Skill Enhancement Course (Any One):</li>
              <ul>
                <li>a) Advertising I</li>
                <li>b) Co-operation I</li>
              </ul>
            </ul>
          </div>

          {/* Fourth Semester */}
          <div className="syllabus-semester">
            <h3>Semester IV (S.Y.B.Com)</h3>
            <ul>
              <li>Accountancy & Financial Management IV</li>
              <li>Discipline Specific Elective (Any One):</li>
              <ul>
                <li>a) Financial Accounting and Auditing – Auditing</li>
                <li>b) Business Management – Marketing Management</li>
              </ul>
              <li>Commerce IV</li>
              <li>Business Economics IV</li>
              <li>Skill Enhancement Course (Any One):</li>
              <ul>
                <li>a) Advertising II</li>
                <li>b) Co-operation II</li>
              </ul>
              <li>Foundation Course</li>
            </ul>
          </div>
        </div>

        <div className="semester-section">
          <h2 className="section-title">Third Year Bachelor of Commerce</h2>

          {/* Fifth Semester */}
          <div className="syllabus-semester">
            <h3>Semester V (T.Y.B.Com)</h3>
            <ul>
              <li>Discipline Specific Elective (Any One Group):</li>
              <ul>
                <li>Group A – Advanced Accountancy:</li>
                <ul>
                  <li>a) Financial Accounting and Auditing – V: Financial Accounting</li>
                  <li>b) Financial Accounting and Auditing – VI: Cost Accounting</li>
                </ul>
                <li>Group B – Business Management:</li>
                <ul>
                  <li>a) Business Management – V: Human Resource Management</li>
                  <li>b) Business Management – VI: Financial Management</li>
                </ul>
              </ul>
              <li>Commerce V</li>
              <li>Business Economics V</li>
              <li>Direct and Indirect Taxation – I</li>
              <li>Export Marketing – I</li>
            </ul>
          </div>

          {/* Sixth Semester */}
          <div className="syllabus-semester">
            <h3>Semester VI (T.Y.B.Com)</h3>
            <ul>
              <li>Discipline Specific Elective (Same Group as Semester V):</li>
              <ul>
                <li>Group A – Advanced Accountancy:</li>
                <ul>
                  <li>a) Financial Accounting and Auditing – VII: Financial Accounting</li>
                  <li>b) Financial Accounting and Auditing – VIII: Auditing</li>
                </ul>
                <li>Group B – Business Management:</li>
                <ul>
                  <li>a) Business Management – VII: Marketing Management</li>
                  <li>b) Business Management – VIII: Production Management</li>
                </ul>
              </ul>
              <li>Commerce VI</li>
              <li>Business Economics VI</li>
              <li>Direct and Indirect Taxation – II</li>
              <li>Export Marketing – II</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BCom;
